import styled from '@emotion/styled';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
`;

export const ImgWrapper = styled.div`
  height: 80px;
  padding: 24px 12px;
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
`;
